import { useMemo } from 'react'
import type { CenterApplicationInfoOut } from '../types/centerApplicationTypes'

interface PatientStats {
  totalSCPatients: number
  totalSCAPatients: number
  totalOtherPatients: number
  totalPatients: number
}

export function usePatientStats(
  application: CenterApplicationInfoOut | undefined
): PatientStats {
  return useMemo(() => {
    if (!application) {
      return {
        totalSCPatients: 0,
        totalSCAPatients: 0,
        totalOtherPatients: 0,
        totalPatients: 0
      }
    }

    const totalSCPatients =
      application.number_of_adult_sc + application.number_of_pediatric_sc
    const totalSCAPatients =
      application.number_of_adult_sca + application.number_of_pediatric_sca
    const totalOtherPatients =
      application.number_of_adult_other + application.number_of_pediatric_other
    const totalPatients =
      totalSCPatients + totalSCAPatients + totalOtherPatients

    return {
      totalSCPatients,
      totalSCAPatients,
      totalOtherPatients,
      totalPatients
    }
  }, [application])
}
